import Vue from 'vue'
import routes from './config/PageRoutes'
import store from './store'
import VueInsProgressBar from 'vue-ins-progress-bar'
import VueCustomScrollbar from 'vue-custom-scrollbar'
// plugins
import VueRouter from 'vue-router'
import VueBootstrap from 'bootstrap-vue'
import VueNotification from 'vue-notification'
import VuePanel from './plugins/panel/'


// plugins css
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'simple-line-icons/css/simple-line-icons.css'
import 'flag-icon-css/css/flag-icon.min.css'
import 'ionicons/dist/css/ionicons.min.css'

// color admin css
import './assets/css/transparent/app.min.css'
import './scss/vue.scss'
import 'bootstrap-social/bootstrap-social.css'

import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(VueBootstrap);
Vue.use(VueNotification);
Vue.use(VuePanel);
Vue.component('vue-custom-scrollbar', VueCustomScrollbar);
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
});

const router = new VueRouter({
  mode: 'history',
	routes
});
new Vue({
  store,
  render: h => h(App),
  router
}).$mount('#app');
